import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import MUITable from "../../Common/MUITable";
import AddEditColony from "./AddEditColony";
import { TableLoader } from "../../Common/ShimmerLoader";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import isGHMC from "../../Common/helper/helpar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GetZone } from "../../Apis/organizationApi";
import { ExportColony } from "./ExportColony";
import { useColonyStore } from "./store/useColonyStore";
import { StatusBadge } from "../Rfid/utils/statusBadge";

const OrganizationColony = () => {
  const isProd = isGHMC();
  const [showModal, setShowModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [zones, setZones] = useState([]);

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || [];

  let canWriteValue = false;

  storedPermissions = parseInt(storedPermissions, 10);

  const matchingPermission = permissionValues1.find(
    (mapping) =>
      mapping.permissionId === storedPermissions &&
      mapping.permissionName === "colonies"
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite === true;
  }

  const {
    filteredColonies,
    isLoading,
    filters,
    fetchColonies,
    applyFilters,
    updateFilter,
  } = useColonyStore();

  const getZoneData = async () => {
    try {
      const zoneResponse = await GetZone();
      const delhiZones = (Array.isArray(zoneResponse) ? zoneResponse : []).filter(
        (zone) =>
          zone.isActive
      );
      setZones(delhiZones);
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };

  useEffect(() => {
    getZoneData();
    fetchColonies();
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    updateFilter(name, value);
    applyFilters();
  };

  const handleAdd = () => {
    setIsEditMode(false);
    setEditRow(null);
    setShowModal(true);
  };

  const handleEdit = (row) => {
    setShowModal(true);
    setIsEditMode(true);
    setEditRow(row);
  };

  const colonyColumns = [
    {
      label: "Zone",
      render: (row) => row.zone || "N/A",
    },
    {
      label: "Ward",
      render: (row) => row.ward || "N/A",
    },
    {
      label: "Colony",
      field: "colonyName",
    },
    {
      label: "Colony Code",
      field: "colonyCode",
    },
    {
      label: "Status",
      render: (row) => <StatusBadge isActive={row.isActive} compact />,
    },
    {
      label: "Action",
      render: (row) => (
        <button
          className={`${isProd ? "edit-ghmc" : "edit-swm"}`}
          onClick={() => handleEdit(row)}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="content text-start">
        <div className="page-content">
          <div className="top-header page-title">
            <span>Colony Details</span>
          </div>
          <div className="d-flex justify-content-end mt-3 align-items-center">
            <div>
              <div className="d-flex justify-content-between">
                {canWriteValue && (
                  <button className="btn btn-excel" onClick={handleAdd}>
                    <i className="fa-solid fa-plus me-1 icon-container"></i>
                    Add Colony
                  </button>
                )}
                <ExportColony colonyData={filteredColonies} />
              </div>
            </div>
          </div>
          <div className="card shadow mt-3">
            <div className="card-body">
              <div className="row align-items-end justify-content-start">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      type="text"
                      name="searchTerm"
                      value={filters.searchTerm}
                      onChange={handleFilterChange}
                      placeholder="Search Colony or Colony Code"
                      className="form-control bg-white"
                    />
                  </div>
                </div>
              </div>
              <div>
                <MUITable loading={isLoading}
                  needSRNumber={true}
                  rows={filteredColonies}
                  columns={colonyColumns}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEditColony
        showModal={showModal}
        setShowModal={setShowModal}
        editRow={editRow}
        isEditMode={isEditMode}
        zoneData={zones}
      />
    </>
  );
};

export default OrganizationColony;
